'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (node) {
	return {
		type: 'MESSAGE_FORM_FIELD',
		name: 'Message Form Field',
		allowedSections: ['footer', 'header', 'main'],
		disallowedChildren: ['*'],
		category: 'Form',
		styleClasses: {},
		props: [{
			label: 'Name',
			name: 'name',
			inputType: 'text',
			default: ''
		}, {
			label: 'Label',
			name: 'label',
			inputType: 'text',
			default: 'My Label'
		}, {
			label: 'Placeholder',
			name: 'placeholder',
			inputType: 'text',
			default: 'My Placeholder..'
		}, {
			label: 'Input type',
			name: 'type',
			inputType: 'select',
			default: '',
			values: [{
				label: '',
				value: ''
			}, {
				label: 'Text',
				value: 'text'
			}, {
				label: 'Textarea',
				value: 'textarea'
			}, {
				label: 'Checkbox',
				value: 'checkbox'
			}, {
				label: 'Radio',
				value: 'radio'
			}, {
				label: 'Password',
				value: 'password'
			}, {
				label: 'Number',
				value: 'number'
			}]
		}, {
			label: 'Field description',
			name: 'hint',
			inputType: 'textarea',
			default: ''
		}, {
			label: 'Required',
			name: 'required',
			inputType: 'checkbox',
			default: false
		}, {
			label: 'Default Value',
			name: 'value',
			inputType: 'text',
			default: ''
		}, node && node.props.type === 'textarea' && {
			label: 'Max Length',
			name: 'textAreaMaxLength',
			inputType: 'number',
			default: 2000
		}, node && node.props.type === 'text' && {
			label: 'Validation',
			name: 'validation',
			inputType: 'select',
			values: [{
				label: '',
				value: ''
			}, {
				label: 'Alphabetical characters',
				value: 'alpha'
			}, {
				label: 'Alphabetical and number characters',
				value: 'alphaNumeric'
			}, {
				label: 'Differs from value X',
				value: 'differs'
			}, {
				label: 'E-Mail',
				value: 'email'
			}, {
				label: 'Exact length',
				value: 'exactLength'
			}, {
				label: 'Greater Than',
				value: 'greaterThan'
			}, {
				label: 'Greater Than or Equal to',
				value: 'greaterThanEqual'
			}, {
				label: 'Lower Than',
				value: 'lowerThan'
			}, {
				label: 'Lower Than or Equal to',
				value: 'lowerThanEqual'
			}, {
				label: 'Matches X',
				value: 'matches'
			}, {
				label: 'Max Length',
				value: 'maxLength'
			}, {
				label: 'Min Length',
				value: 'minLength'
			}, {
				label: 'Natural number',
				value: 'natural'
			}, {
				label: 'Number',
				value: 'number'
			}, {
				label: 'Numeric',
				value: 'numeric'
			}, {
				label: 'RegEx',
				value: 'regex'
			}, {
				label: 'Zip code',
				value: 'zipCode'
			}, {
				label: 'Social Security Number',
				value: 'ssn'
			}, {
				label: 'Company Identification Number',
				value: 'cin'
			}, {
				label: 'Phone',
				value: 'phone'
			}],
			default: ''
		}, node && node.props.validation && ['differs', 'exactLength', 'greaterThan', 'greaterThanEqual', 'lowerThan', 'lowerThanEqual', 'matches', 'maxLength', 'minLength', 'regex'].includes(node.props.validation) && {
			label: 'Compare value',
			name: 'validationCompareValue',
			inputType: 'text',
			default: ''
		}].filter(Boolean),
		hiddenProps: []
	};
};